<div class="drawer-top-bar">
  <div class="drawer-logo-container">
    <img src="assets/images/isotipo_smartbreak.png" alt="SmartBreak" class="app-logo">
  </div>
  <button type="button" (click)="onMenuItemClick()" class="drawer-close-btn" aria-label="Cerrar menú">
    <fa-icon [icon]="faCloseIcon"></fa-icon>
  </button>
</div>

<div class="drawer-body">
  <!-- Perfil del usuario -->
  <div class="profile-card">
    <button type="button" class="profile-btn" data-tour="nav-profile" [routerLink]="['/dashboard/profile']" (click)="onMenuItemClick()">
      <div class="profile-avatar-wrap">
        <div class="profile-avatar-ring">
          <img [src]="avatarImageUrl" alt="Avatar" class="profile-avatar-img" />
        </div>
        <span *ngIf="userLevel" class="profile-level-badge" [ngClass]="userLevel.color">
          {{ userLevel.icon }}
        </span>
      </div>
      <div class="profile-info">
        <span class="profile-name">{{ username }}</span>
        <span class="profile-type">{{ workTypeDisplay }}</span>
      </div>
      <span class="profile-gear" title="Editar perfil">
        <fa-icon [icon]="faGearIcon"></fa-icon>
      </span>
    </button>
  </div>

  <!-- Botón Consola Admin: solo para administradores -->
  <div class="admin-console-entry" *ngIf="isAdmin$ | async">
    <a
      [href]="adminConsoleUrl"
      class="admin-console-btn"
      (click)="onMenuItemClick()"
      title="Abrir Consola de Administración SmartBreak"
    >
      <span class="admin-console-content">
        <span class="admin-console-icon">
          <fa-icon [icon]="faGearIcon"></fa-icon>
        </span>
        <span class="admin-console-label">Consola Admin</span>
      </span>
      <span class="admin-console-badge">ADMIN</span>
    </a>
  </div>

  <!-- Menú de navegación -->
  <nav class="drawer-nav" data-tour="nav-menu">
    <ng-container *ngFor="let item of menuItems; let i = index">
      <a
        *ngIf="item.kind === 'link'"
        [routerLink]="item.route ?? '/dashboard/home'"
        routerLinkActive="nav-link--active"
        [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
        class="nav-link"
        (click)="onMenuItemClick()"
        [style.--anim-delay]="(i + 1) * 0.03 + 's'"
      >
        <span class="nav-link-indicator"></span>
        <span class="nav-link-icon">
          <fa-icon [icon]="item.icon"></fa-icon>
        </span>
        <span class="nav-link-label">{{ item.label | translate }}</span>
      </a>

      <button
        *ngIf="item.kind === 'action'"
        type="button"
        class="nav-link nav-link--action"
        (click)="onActionClick(item.action)"
        [style.--anim-delay]="(i + 1) * 0.03 + 's'"
      >
        <span class="nav-link-indicator"></span>
        <span class="nav-link-icon">
          <fa-icon [icon]="item.icon"></fa-icon>
        </span>
        <span class="nav-link-label">{{ item.label | translate }}</span>
      </button>
    </ng-container>
  </nav>
</div>

<!-- Botón fijo al fondo: Cerrar Sesión (Siempre visible y anclado) -->
<div class="drawer-footer">
  <a
    class="ethical-footer-link"
    [routerLink]="['/dashboard/canal-etico']"
    (click)="onMenuItemClick()"
  >
    <span class="ethical-footer-icon">
      <fa-icon [icon]="faShieldIcon"></fa-icon>
    </span>
    <span>{{ 'MENU.ETHICAL_CHANNEL_FULL' | translate }}</span>
  </a>
  <div class="logout-divider"></div>
  <div class="app-version" [title]="'Compilado: ' + appVersion.builtAt">
    v{{ appVersion.version }} · {{ appVersion.build }}<span *ngIf="appVersion.env !== 'production'"> · {{ appVersion.env }}</span>
  </div>
  <button type="button" class="logout-btn" (click)="onLogoutClick()">
    <span class="logout-btn-icon">
      <fa-icon [icon]="faSignOutIcon"></fa-icon>
    </span>
    <span class="logout-btn-label">{{ 'MENU.LOGOUT' | translate }}</span>
  </button>
</div>

<!-- Ventana flotante: cambiar a otra app de la suite -->
<ion-modal class="suite-modal" [isOpen]="suiteOpen" (didDismiss)="suiteOpen = false">
  <ng-template>
    <div class="suite-dialog">
      <div class="suite-dialog-head">
        <div>
          <p class="suite-dialog-title">SmartSuite</p>
          <p class="suite-dialog-sub">¿A qué app quieres cambiar?</p>
        </div>
        <button type="button" class="drawer-close-btn" aria-label="Cerrar" (click)="suiteOpen = false">
          <fa-icon [icon]="faCloseIcon"></fa-icon>
        </button>
      </div>
      <div class="suite-grid">
        <a
          *ngFor="let app of suiteApps"
          class="suite-card"
          [href]="app.url"
          rel="noopener"
          [style.--suite-color]="(suiteMeta[app.key] ?? suiteFallback).color"
        >
          <span class="suite-card-pic">
            <img [src]="'assets/suite/' + app.key + '.webp'" alt="" width="48" height="48" />
          </span>
          <span class="suite-card-name">{{ app.name }}</span>
          <span class="suite-card-tag">{{ (suiteMeta[app.key] ?? suiteFallback).tag }}</span>
        </a>
      </div>
    </div>
  </ng-template>
</ion-modal>
